import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { fetchMPById } from "../api/fakeGetMPByID";
import "../styles/MPOverview.css";

export default function MPOverview() {
  const { id } = useParams(); // get the :id from the route
  const navigate = useNavigate();
  const [mp, setMp] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchMPById(id)
      .then(setMp)
      .catch((err) => setError(err.message));
  }, [id]);

  if (error) return <p>Error: {error}</p>;
  if (!mp) return <p>Loading...</p>;

  return (
    <div className="mp-overview-wrapper">
      <button className="back-link" onClick={() => navigate(-1)}>
        <img
          src="/icons/common_back_icon.png"
          alt="Back"
          className="back-icon"
        />
        Back to Matches
      </button>

      <div className="mp-overview-card">
        <img className="mp-image" src={mp.imageUrl} alt={mp.name} />

        <div className="mp-info">
          <h2 className="overview-mp-name">{mp.name}</h2>
          <p className="overview-mp-role">
            <strong>Current role :</strong> {mp.role}
          </p>

          <ul className="mp-details">
            <li>
              <span className="dot"></span>
              {mp.party}
            </li>
            <br />
            <li>Constituency: {mp.constituency}</li>
            <li>In office since {mp.inOfficeSince} – Present</li>
          </ul>

          <div className="highlight-box">
            <strong>Top Matching Issues:</strong>
            <br />
            {mp.topIssues.join(", ")}
          </div>
        </div>
      </div>
    </div>
  );
}
